import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const RemoveCanvasButton = () => {
    const [buttonState, setButtonState] = useState(true);
    const location = useLocation();

    useEffect(()=>{
        setButtonState(true);
        console.log(location);
    },[location]);


    function removeAllCanvas(){
    const canvases = document.querySelectorAll("canvas")
    canvases.forEach( (currentValue)=>{
        currentValue.remove();
        setButtonState(false);});

}

    return(
        <>
        {buttonState && <button className="show-all-score-btn"onClick={removeAllCanvas}>Show All Scores</button>}
        </>
    )
    

}
export default RemoveCanvasButton;